const PAYCOM_SRC = 'https://js.pay.com/v1?disabled_scripts=rs';

const ensurePaycomScript = () => {
  if (document.getElementById('paycom-script')) return;
  const s = document.createElement('script');
  s.id = 'paycom-script';
  s.src = PAYCOM_SRC;
  s.defer = true;
  s.crossOrigin = 'anonymous';
  document.head.appendChild(s);
};

export const warmupPaycomScript = () => {
  ensurePaycomScript();
};
